import { MeasurementType } from '@src/core/features/settings/entities';
import { UnitType } from '@src/core/enums';

const CONVERSION_FACTORS: Record<MeasurementType, number> = {
  [MeasurementType.DISTANCE]: 3.28084,
  [MeasurementType.SPEED]:    2.23694,
  [MeasurementType.NONE]:     1,
};

export const arcConvertUnit = (
  value: number,
  measurementType: MeasurementType,
  unitType: UnitType,
): number => {
  if (unitType === UnitType.SI) return value;
  return Math.round(value * CONVERSION_FACTORS[measurementType]);
};
